export const updateCompareUrl = (models) => {
  const ids = models.map(m => m.id);
  history.replaceState({}, '', `?compare-specs=${ids.join(',')}`);
}